<template>
    <ion-menu content-id="main-content" type="overlay">
        <ion-header>
            <ion-toolbar>
                <ion-title>Menu</ion-title>
            </ion-toolbar>
        </ion-header>
        <ion-content>
            <ion-list>
                <ion-item
                    button
                    :detail="true"
                    @click="navigateTo('home')"
                    :class="{ 'menu-item-active': isActive('home') }">
                    <ion-icon :icon="homeOutline" slot="start"></ion-icon>
                    <ion-label>Home</ion-label>
                </ion-item>
                <ion-item
                    button
                    :detail="true"
                    @click="navigateTo('costumers')"
                    :class="{ 'menu-item-active': isActive('costumers') }">
                    <ion-icon :icon="peopleOutline" slot="start"></ion-icon>
                    <ion-label>Clienti</ion-label>
                </ion-item>
                <ion-item
                    button
                    :detail="true"
                    @click="navigateTo('planning')"
                    :class="{ 'menu-item-active': isActive('planning') }">
                    <ion-icon :icon="listCircleOutline" slot="start"></ion-icon>
                    <ion-label>Pianificazione</ion-label>
                </ion-item>
                <ion-item
                    button
                    :detail="true"
                    @click="navigateTo('calendar')"
                    :class="{ 'menu-item-active': isActive('calendar') }">
                    <ion-icon :icon="calendarOutline" slot="start"></ion-icon>
                    <ion-label>Calendario</ion-label>
                </ion-item>
                <ion-item
                    button
                    :detail="true"
                    @click="navigateTo('contractExpirations')"
                    :class="{ 'menu-item-active': isActive('contractExpirations') }">
                    <ion-icon :icon="alertCircleOutline" slot="start"></ion-icon>
                    <ion-label>Scadenze Contratti</ion-label>
                </ion-item>

                <!-- <ion-button
                    fill="clear"
                    style="--color: var(--ion-color-dark)"
                    @click="$router.push({ name: 'zones' })">
                    <ion-icon :icon="mapOutline" slot="start"></ion-icon>
                    <span>Aree</span>
                </ion-button> -->
                <ion-item
                    button
                    :detail="true"
                    @click="navigateTo('zones')"
                    :class="{ 'menu-item-active': isActive('zones') }">
                    <ion-icon :icon="locateOutline" slot="start"></ion-icon>
                    <ion-label>Aree</ion-label>
                </ion-item>
                <ion-item
                    button
                    :detail="true"
                    @click="navigateTo('settings')"
                    :class="{ 'menu-item-active': isActive('settings') }">
                    <ion-icon :icon="cogOutline" slot="start"></ion-icon>
                    <ion-label>Impostazioni</ion-label>
                </ion-item>
            </ion-list>
        </ion-content>
    </ion-menu>
</template>

<script setup lang="ts">
import {
    IonMenu,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonList,
    IonItem,
    IonIcon,
    IonLabel,
    menuController,
} from "@ionic/vue";
import { useRouter, useRoute } from "vue-router";
import {
    peopleOutline,
    cogOutline,
    listCircleOutline,
    calendarOutline,
    mapOutline,
    locateOutline,
    alertCircleOutline,
    homeOutline,
} from "ionicons/icons";

const router = useRouter();
const route = useRoute();

const navigateTo = async (routeName: string) => {
    await menuController.close();
    router.push({ name: routeName });
};

const isActive = (routeName: string) => {
    return route.name === routeName;
};
</script>

<style scoped>
.menu-item-active {
    --background: var(--ion-color-primary-tint);
    font-weight: bold;
}
</style>
